/**
 * TenderChatMessageArea — Message list for tender chat.
 *
 * Forked from ChatMessageArea.tsx, wired to useTenderChatStore.
 * Reuses the shared MessageBubble component. While a turn streams, the §2.7
 * ActivityPhases view replaces the old single transient status line.
 */

import { useEffect, useRef } from "react"
import { ScrollArea } from "@/components/ui/scroll-area"
import { useTenderChatStore } from "@/stores/tender-chat-store"
import { MessageBubble } from "@/components/assistant/MessageBubble"
import { ActivityPhases } from "@/components/chat/ActivityPhases"

export function TenderChatMessageArea() {
  const { messages, isStreaming, activityPhases } = useTenderChatStore()
  const undoMemorySaved = useTenderChatStore((s) => s.undoMemorySaved)
  const scrollRef = useRef<HTMLDivElement>(null)

  const handleUndoMemory = (messageId: string, memoryId: string) => {
    void undoMemorySaved(messageId, memoryId)
  }

  const hasPhases = activityPhases.phases.length > 0

  // Auto-scroll to bottom on new messages or activity changes
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [messages.length, isStreaming, activityPhases])

  if (messages.length === 0) {
    return null // Empty state handled by parent TenderChat
  }

  return (
    <ScrollArea className="h-full" ref={scrollRef}>
      <div className="max-w-3xl mx-auto px-4 py-6 space-y-4">
        {messages.map((message) => (
          <MessageBubble key={message.id} message={message} onUndoMemory={handleUndoMemory} />
        ))}
        {hasPhases && (
          <div>
            <ActivityPhases phases={activityPhases} isStreaming={isStreaming} />
          </div>
        )}
      </div>
    </ScrollArea>
  )
}
